
function formatIndianNumber(number) {
    const str = number?.toLocaleString('en-IN');
    return str  
}

export default formatIndianNumber;
